import React from "react";
import { __ } from "@wordpress/i18n";
import Constants from "../constants";
import BSHelper from "../BSHelper";

const VolunteersList = ({ volunteers, phrases }) => {
	console.log(volunteers);
	const strPostedSince = __(phrases.posted_since, Constants.TEXT_DOMAIN);
	const strDay = __(phrases.day, Constants.TEXT_DOMAIN);
	const strDays = __(phrases.days, Constants.TEXT_DOMAIN);
	const strHour = __(phrases.hour, Constants.TEXT_DOMAIN);
	const strHours = __(phrases.hours, Constants.TEXT_DOMAIN);
	const strVolunteer = __(phrases.volunteer, Constants.TEXT_DOMAIN);
	const strVolunteers = __(phrases.volunteers, Constants.TEXT_DOMAIN);


	return (
		<div className="grid grid-cols-1 gap-4 volunteers-list md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
			{volunteers.length > 0 ? (volunteers.map((volunteer) => {
				const postedSinceDays = BSHelper.getPostedDays(volunteer.datePosted);
				const applyButtonUrl = volunteer.showApply ? `${bseitEditorVars.currentLang === "ar" ? "/ar" : ""}/volunteer-details/?id=${volunteer.id}` : "#";
				const applyButtonActiveClass = volunteer.showApply ? "cursor-pointer" : "cursor-not-allowed";

				return (
					<div
						className="p-5 border rounded-lg volunteer-card border-semiGray"
						key={volunteer.id}
					>
						<div className="flex flex-row items-center">
							<div className="flex flex-row items-center me-8">
								<img
									src={wpApiSettings.bseit_assets_dir_url + "icons/location-pin.svg"}
									className="object-cover w-6 me-1"
									alt="location-pin-icon"
									loading="lazy"
								/>
								<p className="text-sm font-light text-[#909da2]">{BSHelper.truncate(volunteer.location, 20)}</p>
							</div>
							<div className="flex flex-row items-center">
								<img
									src={wpApiSettings.bseit_assets_dir_url + "icons/calendar.svg"}
									className="object-cover w-6 me-1"
									alt="calendar-icon"
									loading="lazy"
								/>
								<p className="text-sm font-light text-[#909da2]">{`${strPostedSince} ${postedSinceDays}  ${volunteer.minimumHours === '1' ? strDay : strDays}`}</p>
							</div>
						</div>

						<h3 className="py-2 font-bold text-[#000000] lg:py-3"><a
							href={applyButtonUrl} className={`${applyButtonActiveClass} hover:underline`}
							aria-label="Button"
							{...volunteer.showApply ? {} : { disabled: true }}
							onClick={(e) => {
								if (!volunteer.showApply) {
									e.preventDefault();
								}
							}}>{BSHelper.truncate(volunteer.title, 40)}</a></h3>

						<div className="flex flex-row items-start">
							<div className="flex flex-col items-start me-8">
								<p className="text-[#909da2]">
									{__(phrases.number_of_required_volunteers, Constants.TEXT_DOMAIN)}
								</p>
								<h4 className="text-[#22282B]">{`${volunteer.numberOfVolunteers} ${volunteer.numberOfVolunteers === '1' ? strVolunteer : strVolunteers}`}</h4>
							</div>
							<div className="flex flex-col items-start">
								<p className="text-[#909da2]">
									{__(phrases.duration_of_volunteering, Constants.TEXT_DOMAIN)}
								</p>
								<h4 className="text-[#22282B]">{`${volunteer.minimumVolunteerHours} ${volunteer.minimumHours === '1' ? strHour : strHours}`}</h4>
							</div>
						</div>

						<div className="flex items-center justify-center w-full pt-4">
							<a
								href={applyButtonUrl}
								className={`${applyButtonActiveClass} ${volunteer.showApply ? 'text-[#800038] transition-all bg-white border-[#800038] hover:bg-[#800038] hover:text-white hover:border hover:border-[#800038]' : 'text-white bg-[#909DA2] border-[#909DA2]'} w-full border rounded-[82px] py-3 text-center transition-all px-9 apply-button`}
								aria-label="Button"
								{...volunteer.showApply ? {} : { disabled: true }}
								onClick={(e) => {
									if (!volunteer.showApply) {
										e.preventDefault();
									}
								}}
							>
								{__(phrases.apply_now, Constants.TEXT_DOMAIN)}
							</a>
						</div>
					</div>)
			})) : (<p>{__(phrases.no_volunteers_found, Constants.TEXT_DOMAIN)}</p>)}
		</div>

	);
};

export default VolunteersList;
